import Vue from 'vue'
import CryptoJS from 'crypto-js'
// import md5 from 'js-md5';
import {
  Toast,
  Indicator
} from 'mint-ui'
import {
  exchangeXztoken,
  sharePath
} from '@/service/getData'
/**
 * md5加密
 */
// Vue.prototype.$md5  = md5;
/**
 * 获取经纬度
 */
Vue.prototype.getPosition = function () {
  return new Promise((resolve, reject) => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        function (position) {
          const latitude = position.coords.latitude
          const longitude = position.coords.longitude
          const data = {
            latitude: latitude,
            longitude: longitude
          }
          resolve(data)
        },
        function () {
          reject(arguments)
        }
      )
    } else {
      Toast('你的浏览器不支持当前地理位置信息获取')
      // reject('你的浏览器不支持当前地理位置信息获取')
    }
  })
}
/**
 * 设置校验
 */
Vue.prototype.setSign = function (data) {
  let dataStr = ''
  Object.keys(data).forEach(key => {
    dataStr += key + '=' + data[key] + '&'
  })
  dataStr = this.$md5(dataStr)
  return dataStr
}
/**
 * 存储localStorage
 */
Vue.prototype.setStore = function (name, content) {
  if (!name) return
  if (typeof content !== 'string') {
    content = JSON.stringify(content)
  }
  window.localStorage.setItem(name, content)
  if (name === 'userInfo' && localStorage.getItem("userInfo")) {
    sensors.login(JSON.parse(localStorage.getItem("userInfo")).userId)
  }
}
/**
 * 获取localStorage
 */
Vue.prototype.getStore = function (name) {
  if (!name) return
  return window.localStorage.getItem(name)
}
/**
 * 删除localStorage
 */
Vue.prototype.removeStore = function (name) {
  if (!name) return
  window.localStorage.removeItem(name)
}
/**
 * 设置cookie
 */
Vue.prototype.setCookie = function (name, value, time) {
  const Days = 30
  const exp = new Date()
  const expTime = !time ? Days * 24 * 60 * 60 * 1000 : time * 1000
  exp.setTime(exp.getTime() + expTime)
  const domain = process.env.NODE_ENV === "development" ? ';Domain=0.0.0.0' : ';Domain=.xiaozhu.com'
  document.cookie = name + '=' + escape(value) + ';expires=' + exp.toGMTString() + domain
}
/**
 * 获取cookie
 */
Vue.prototype.getCookie = function (name) {
  let arr
  const reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
  if ((arr = document.cookie.match(reg))) return unescape(arr[2])
  else return null
}
/**
 * 删除cookie
 */
Vue.prototype.deleteCookie = function (name) {
  const exp = new Date()
  exp.setTime(exp.getTime() - 1)
  const cval = xz.cookie.get(name)
  if (cval != null) document.cookie = name + '=' + cval + ';expires=' + exp.toGMTString()
}
/**
 *  检测登录
 * */
Vue.prototype.$isLogin = function () {
  return !!((localStorage.getItem('userInfo') && this.getCookie('userInfo')))
}

/**
 *  读取分享URL参数
 * */
Vue.prototype.$getShareParam = function (url) {
  var url = url.split('#')[1]
  const reg_url = /^[^\?]+\?([\w\W]+)$/
  const reg_para = /([^&=]+)=([\w\W]*?)(&|$)/g // g is very important
  const arr_url = reg_url.exec(url)
  const ret = {}
  if (arr_url && arr_url[1]) {
    const str_para = arr_url[1]
    let result
    while ((result = reg_para.exec(str_para)) != null) {
      ret[result[1]] = result[2]
    }
  }
  return ret
}

/**
 *  读取URL参数
 * */
Vue.prototype.$getParam = function (paramName, urlString) {
  const sURL = urlString || window.document.URL.toString().replace(/#/, '&')
  if (sURL.indexOf('?') > 0) {
    const arrParams = sURL.split('?')
    // const arrURLParams = arrParams[1].split('&')
    let arrURLParams = []
    if (arrParams.length > 2) {
      arrURLParams = arrParams[2].split("&").concat(arrParams[1].split("&"));
    } else {
      arrURLParams = arrParams[1].split("&");
    }
    const arrParamNames = new Array(arrURLParams.length)
    const arrParamValues = new Array(arrURLParams.length)
    for (var i = 0; i < arrURLParams.length; i++) {
      const sParam = arrURLParams[i].split('=')
      arrParamNames[i] = sParam[0]
      if (sParam[1] != '') {
        arrParamValues[i] = unescape(sParam[1])
      } else {
        arrParamValues[i] = ''
      }
    }
    for (i = 0; i < arrURLParams.length; i++) {
      if (arrParamNames[i] == paramName) {
        return arrParamValues[i] == 'undefined' ? '' : arrParamValues[i]
      }
    }
    return ''
  }
  return ''
}
/**
 *  是否支持webp格式图片
 * */
Vue.prototype.$is_supportWebP = function () {
  return (
    document
    .createElement('canvas')
    .toDataURL('image/webp')
    .indexOf('data:image/webp') == 0
  )
}
/**
 * button倒计时
 */
Vue.prototype.countDown = function (time) {
  const _this = this
  if (time == 0) {
    _this.disabled = false
    _this.smsText = '再次获取'
  } else {
    _this.disabled = true
    _this.smsText = time + '秒后重发'
    time--
    setTimeout(function () {
      _this.countDown(time)
    }, 1000)
  }
}
Vue.prototype.getUrlParms = function (name) {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  const r = window.location.search.substr(1).match(reg)
  if (r != null) return unescape(r[2])
  return null
}
/**
 * 获取style样式
 */
export const getStyle = (element, attr, NumberMode = 'int') => {
  let target
  // scrollTop 获取方式不同，没有它不属于style，而且只有document.body才能用
  if (attr === 'scrollTop') {
    target = element.scrollTop
  } else if (element.currentStyle) {
    target = element.currentStyle[attr]
  } else {
    target = document.defaultView.getComputedStyle(element, null)[attr]
  }
  // 在获取 opactiy 时需要获取小数 parseFloat
  return NumberMode == 'float' ? parseFloat(target) : parseInt(target)
}
/**
 * 页面到达底部，加载更多
 */
export const loadMore = (element, callback) => {
  const windowHeight = window.screen.height
  let height
  let setTop
  let paddingBottom
  let marginBottom
  let requestFram
  let oldScrollTop

  document.body.addEventListener(
    'scroll',
    () => {
      loadMore()
    },
    false
  )
  // 运动开始时获取元素 高度 和 offseTop, pading, margin
  element.addEventListener(
    'touchstart',
    () => {
      height = element.offsetHeight
      setTop = element.offsetTop
      paddingBottom = getStyle(element, 'paddingBottom')
      marginBottom = getStyle(element, 'marginBottom')
    }, {
      passive: true
    }
  )

  // 运动过程中保持监听 scrollTop 的值判断是否到达底部
  element.addEventListener(
    'touchmove',
    () => {
      loadMore()
    }, {
      passive: true
    }
  )

  // 运动结束时判断是否有惯性运动，惯性运动结束判断是非到达底部
  element.addEventListener(
    'touchend',
    () => {
      oldScrollTop = document.body.scrollTop
      moveEnd()
    }, {
      passive: true
    }
  )

  const moveEnd = () => {
    requestFram = requestAnimationFrame(() => {
      if (document.body.scrollTop != oldScrollTop) {
        oldScrollTop = document.body.scrollTop
        loadMore()
        moveEnd()
      } else {
        cancelAnimationFrame(requestFram)
        // 为了防止鼠标抬起时已经渲染好数据从而导致重获取数据，应该重新获取dom高度
        height = element.offsetHeight
        loadMore()
      }
    })
  }

  const loadMore = () => {
    if (document.body.scrollTop + windowHeight >= height + setTop + paddingBottom + marginBottom) {
      callback()
    }
  }
}

/**
 * 显示返回顶部按钮，开始、结束、运动 三个过程中调用函数判断是否达到目标点
 */
export const showBack = callback => {
  let requestFram
  let oldScrollTop

  document.addEventListener(
    'scroll',
    () => {
      showBackFun()
    },
    false
  )
  document.addEventListener(
    'touchstart',
    () => {
      showBackFun()
    }, {
      passive: true
    }
  )

  document.addEventListener(
    'touchmove',
    () => {
      showBackFun()
    }, {
      passive: true
    }
  )

  document.addEventListener(
    'touchend',
    () => {
      oldScrollTop = document.body.scrollTop
      moveEnd()
    }, {
      passive: true
    }
  )

  const moveEnd = () => {
    requestFram = requestAnimationFrame(() => {
      if (document.body.scrollTop != oldScrollTop) {
        oldScrollTop = document.body.scrollTop
        moveEnd()
      } else {
        cancelAnimationFrame(requestFram)
      }
      showBackFun()
    })
  }

  // 判断是否达到目标点
  const showBackFun = () => {
    if (document.body.scrollTop > 500) {
      callback(true)
    } else {
      callback(false)
    }
  }
}

/**
 * 运动效果
 * @param {HTMLElement} element   运动对象，必选
 * @param {JSON}        target    属性：目标值，必选
 * @param {number}      duration  运动时间，可选
 * @param {string}      mode      运动模式，可选
 * @param {function}    callback  可选，回调函数，链式动画
 */
export const animate = (element, target, duration = 400, mode = 'ease-out', callback) => {
  clearInterval(element.timer)

  // 判断不同参数的情况
  if (duration instanceof Function) {
    callback = duration
    duration = 400
  } else if (duration instanceof String) {
    mode = duration
    duration = 400
  }

  // 判断不同参数的情况
  if (mode instanceof Function) {
    callback = mode
    mode = 'ease-out'
  }

  // 获取dom样式
  const attrStyle = attr => {
    if (attr === 'opacity') {
      return Math.round(getStyle(element, attr, 'float') * 100)
    } else {
      return getStyle(element, attr)
    }
  }
  // 根字体大小，需要从此将 rem 改成 px 进行运算
  const rootSize = parseFloat(document.documentElement.style.fontSize)

  const unit = {}
  const initState = {}

  // 获取目标属性单位和初始样式值
  Object.keys(target).forEach(attr => {
    if (/[^\d^\.]+/gi.test(target[attr])) {
      unit[attr] = target[attr].match(/[^\d^\.]+/gi)[0] || 'px'
    } else {
      unit[attr] = 'px'
    }
    initState[attr] = attrStyle(attr)
  })

  // 去掉传入的后缀单位
  Object.keys(target).forEach(attr => {
    if (unit[attr] == 'rem') {
      target[attr] = Math.ceil(parseInt(target[attr]) * rootSize)
    } else {
      target[attr] = parseInt(target[attr])
    }
  })

  let flag = true // 假设所有运动到达终点
  const remberSpeed = {} // 记录上一个速度值,在ease-in模式下需要用到
  element.timer = setInterval(() => {
    Object.keys(target).forEach(attr => {
      let iSpeed = 0 // 步长
      let status = false // 是否仍需运动
      const iCurrent = attrStyle(attr) || 0 // 当前元素属性址
      let speedBase = 0 // 目标点需要减去的基础值，三种运动状态的值都不同
      let intervalTime // 将目标值分为多少步执行，数值越大，步长越小，运动时间越长
      switch (mode) {
        case 'ease-out':
          speedBase = iCurrent
          intervalTime = (duration * 5) / 400
          break
        case 'linear':
          speedBase = initState[attr]
          intervalTime = (duration * 20) / 400
          break
        case 'ease-in':
          const oldspeed = remberSpeed[attr] || 0
          iSpeed = oldspeed + (target[attr] - initState[attr]) / duration
          remberSpeed[attr] = iSpeed
          break
        default:
          speedBase = iCurrent
          intervalTime = (duration * 5) / 400
      }
      if (mode !== 'ease-in') {
        iSpeed = (target[attr] - speedBase) / intervalTime
        iSpeed = iSpeed > 0 ? Math.ceil(iSpeed) : Math.floor(iSpeed)
      }
      // 判断是否达步长之内的误差距离，如果到达说明到达目标点
      switch (mode) {
        case 'ease-out':
          status = iCurrent != target[attr]
          break
        case 'linear':
          status = Math.abs(Math.abs(iCurrent) - Math.abs(target[attr])) > Math.abs(iSpeed)
          break
        case 'ease-in':
          status = Math.abs(Math.abs(iCurrent) - Math.abs(target[attr])) > Math.abs(iSpeed)
          break
        default:
          status = iCurrent != target[attr]
      }

      if (status) {
        flag = false
        // opacity 和 scrollTop 需要特殊处理
        if (attr === 'opacity') {
          element.style.filter = 'alpha(opacity:' + (iCurrent + iSpeed) + ')'
          element.style.opacity = (iCurrent + iSpeed) / 100
        } else if (attr === 'scrollTop') {
          element.scrollTop = iCurrent + iSpeed
        } else {
          element.style[attr] = iCurrent + iSpeed + 'px'
        }
      } else {
        flag = true
      }

      if (flag) {
        clearInterval(element.timer)
        if (callback) {
          callback()
        }
      }
    })
  }, 20)
}

/*
 *  获取sign值
 */
export const getSign = module => {
  let signstr = ''
  const ts = new Date().getTime()
  const __signkey = 'xiao_!@&^~&html5*_zhu_121210'
  const signs = {
    servicename: module,
    sign: __signkey,
    timestamp: ts
  }
  for (const key in signs) signstr += key + '=' + signs[key]
  signstr = CryptoJS.MD5(signstr).toString(CryptoJS.enc.Base64)

  return signstr
}
/*
 * APP内获取token
 */
Vue.prototype.exchangeToken = function (callback, loading = true) {
  const that = Vue.prototype
  that.webView.getAllValue()
  let xzToken = ''
  if (!that.$getUa.userAgent.isIpad) {
    if (loading) {
      Indicator.open()
    }
  }
  setTimeout(function () {
    if (that.webView.response) {
      let userInfo = that.webView.response && that.webView.response.userInfo
      if (userInfo) {
        userInfo = JSON.parse(userInfo)
        that.setStore('appVersion', that.webView.response.appVersion)
        if (userInfo.xztoken) {
          xzToken = userInfo.xztoken
        }
      } else {
        if (callback) {
          callback()
        }
        if (loading) {
          Indicator.close()
        }
      }
    }
    if (xzToken) {
      const params = {
        xztoken: xzToken
      }
      that.$get(exchangeXztoken, params).then(res => {
        if (loading) {
          Indicator.close()
        }
        if (res.status != 200) return Toast(res.errorMsg)
        if (res.content) {
          that.setStore('userInfo', res.content)
          that.setStore('jsversion', 'd7m4g9s8')
          that.setStore('d7m4g9s8xzlogin', true)
          that.setStore('d7m4g9s8xzuser', res.content)
          if (callback) callback()
        }
      })
    }
  }, 1000)
}
/**
 * 支付宝小程序换取token；
 */
Vue.prototype.miniChatExchangeToken = function (xzToken, callback) {
  const that = Vue.prototype
  Indicator.open()
  if (xzToken) {
    const params = {
      xztoken: xzToken
    }
    that.$get(exchangeXztoken, params).then(res => {
      setTimeout(function () {
        Indicator.close()
      }, 100)
      if (res.status != 200) return Toast(res.errorMsg)
      if (res.content) {
        that.setStore('userInfo', res.content)
        that.setStore('jsversion', 'd7m4g9s8')
        that.setStore('d7m4g9s8xzlogin', true)
        that.setStore('d7m4g9s8xzuser', res.content)
        that.setStore('aliFlag', true)
        // 刷新下页面
        window.location.reload()
        // if (callback) callback();
      }
    })
  }
}
/**
 * h5端 m站通用换取token；
 * backUrl 登录完成 返回的页面
 */
Vue.prototype.commonExchangeToken = function (xzToken, callback, backUrl) {
  const that = Vue.prototype
  Indicator.open()
  if (xzToken) {
    const params = {
      xztoken: xzToken
    }
    that.$get(exchangeXztoken, params).then(res => {
      setTimeout(function () {
        Indicator.close()
      }, 100)
      if (res.status == 4203) {
        // token过期 清理缓存，跳转至登录页面
        localStorage.clear()
        const urls = backUrl || ''
        if (urls) {
          return that.$router.push('/login?r=' + urls)
        } else {
          return that.$router.push('/login=')
        }
      }
      if (res.status != 200) return Toast(res.errorMsg)
      if (res.content) {
        const loginData = res.content
        loginData.userid = res.content.userId
        loginData.sessid = res.content.sessId
        that.setStore('userInfo', res.content)
        that.setStore('jsversion', 'd7m4g9s8')
        that.setStore('d7m4g9s8xzlogin', true)
        this.setStore('xzuser', loginData)
        that.setStore('d7m4g9s8xzuser', res.content)
        that.setStore('aliFlag', true)
        // 刷新下页面
        if (callback) callback()
      }
    })
  }
}
/**
 *
 * 微信分享配置接口
 *
 */
Vue.prototype.setShare = function () {
  const that = Vue.prototype
  const ua = navigator.userAgent.toLowerCase()
  const params = {
    type: 'weixin'
  }
  if (ua.indexOf('micromessenger') > -1) {
    that.$get(sharePath, params).then(res => {
      if (res.status != 200) return
      if (res.content && wx) {
        wx.config(res.content)
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/config/mUtils.js